(function(win, doc) {
    function change() {
        win.rem = doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 18.75 + "px"
    }

    win.addEventListener("resize", change, false)
    win.addEventListener("DOMContentLoaded", change, false)
})(window, document)
